export enum Domain {
    ALIRO = 'app.aliroimmigration.com',
    ALIROD6903 = 'aliro-d6903.web.app',
    BASTIN = 'app.bastinandcompany.com',
    BIZBUDDY = 'visas.bizbuddy.ca',
    DEMO = 'demo.aliroimmigration.com',
    DEV = 'dev.aliroimmigration.com',
    EASY = 'easy.aliroimmigration.com',
    GLOBALCITIZENS = 'app.globalcitizens.asia',
    GREATNORTHVISA = 'info.greatnorthvisa.com',
    JOSHUASLAYEN = 'app.joshuaslayen.com',
    LOCAL = 'localhost',
    LOOKNOFURTHER = 'app.looknofurther.co',
    MDCPORTAL = 'mdcportal.ca',
    MEDIACRUSH = 'info.uiscanada.com',
    RESOLVED = 'app.weresolved.com',
    TEAMSTAFFINGINTERNATIONAL = 'app.teamstaffingint.com',
    UIS_AUSTRALIA = 'info.uis-australia.com',
    UISAUSTRALIA = 'info.uisaustralia.com',
    UISUK = 'info.uisuk.com',
    FEATURE = 'feature.aliroimmigration.ai',
    NEWDAYIMMIGRATION = 'app.newdayimmigrationinc.com',
    ALIROAUSTRALIA = 'au.aliroimmigration.com',
    ALIROCANADA = 'ca.aliroimmigration.com',
    ALIROUK = 'uk.aliroimmigration.com',
    AUSSIEMIGRATE = 'app.aussiemigrate.com',
    SANDBOX = 'sandbox.aliroimmigration.com',
}

export interface DomainType {
    [key: string]: string;
}

export const DOMAIN_KEYS: DomainType = {
    [Domain.ALIRO]: process.env.REACT_APP_ALIRO_URL!,
    [Domain.ALIROD6903]: process.env.REACT_APP_B2B_URL!,
    [Domain.BASTIN]: process.env.REACT_APP_B2B_URL!,
    [Domain.BIZBUDDY]: process.env.REACT_APP_B2B_URL!,
    [Domain.DEMO]: process.env.REACT_APP_DEMO_URL!,
    [Domain.DEV]: process.env.REACT_APP_DEV_URL!,
    [Domain.EASY]: process.env.REACT_APP_B2B_URL!,
    [Domain.GLOBALCITIZENS]: process.env.REACT_APP_B2B_URL!,
    [Domain.GREATNORTHVISA]: process.env.REACT_APP_B2B_URL!,
    [Domain.JOSHUASLAYEN]: process.env.REACT_APP_B2B_URL!,
    [Domain.LOCAL]: process.env.REACT_APP_LOCAL_URL!,
    [Domain.LOOKNOFURTHER]: process.env.REACT_APP_B2B_URL!,
    [Domain.MDCPORTAL]: process.env.REACT_APP_B2B_URL!,
    [Domain.MEDIACRUSH]: process.env.REACT_APP_B2B_URL!,
    [Domain.RESOLVED]: process.env.REACT_APP_B2B_URL!,
    [Domain.TEAMSTAFFINGINTERNATIONAL]: process.env.REACT_APP_B2B_URL!,
    [Domain.UISAUSTRALIA]: process.env.REACT_APP_B2B_URL!,
    [Domain.UIS_AUSTRALIA]: process.env.REACT_APP_B2B_URL!,
    [Domain.UISUK]: process.env.REACT_APP_B2B_URL!,
    [Domain.FEATURE]: process.env.REACT_APP_DEV_URL!,
    [Domain.NEWDAYIMMIGRATION]: process.env.REACT_APP_B2B_URL!,
    [Domain.ALIROAUSTRALIA]: process.env.REACT_APP_B2B_URL!,
    [Domain.ALIROCANADA]: process.env.REACT_APP_B2B_URL!,
    [Domain.ALIROUK]: process.env.REACT_APP_B2B_URL!,
    [Domain.AUSSIEMIGRATE]: process.env.REACT_APP_B2B_URL!,
    [Domain.SANDBOX]: process.env.REACT_APP_DEV_URL!,
};

const currentDomain: string = window.location.hostname.toString();
const indexOfS = Object.values(Domain).indexOf(currentDomain as unknown as Domain);
export const DomainKey = Object.keys(Domain)[indexOfS];
